import { useAxiosPost } from "../../infrastructure/http";
import { Receive } from "../Receive";
import { PostReceiveResponse } from "./Models/PostReceiveResponse";

export function usePostReceive(manual?: boolean) {
    return useAxiosPost<Receive, PostReceiveResponse>("/Receive", manual ?? false);
}